// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<g fillRule="nonzero" stroke="currentColor" fill="none">
				<circle id="bg" cx="8" cy="8" r="7.5"></circle>
			</g>
			<g transform="translate(3.733333, 3.733333)">
				<path d="M2.91724113,7.1070694 C2.57048042,7.45383011 2.57651532,7.99730628
					2.91544345,8.33623441 C3.25673453,8.67752549 3.8046875,8.67435769
					4.14460847,8.33443673 L7.20943144,5.26961376 C7.38157406,5.09747114
					7.4661074,4.87564258 7.46578728,4.65389369 C7.46663563,4.42975161
					7.38040034,4.20961996 7.21122912,4.04044874 L4.14460847,0.973828092
					C3.79784775,0.627067376 3.25437158,0.63310228 2.91544345,0.97203041
					C2.57415238,1.31332149 2.57732017,1.86127446 2.91724113,2.20119543
					 L5.37017812,4.65413241 L2.91724113,7.1070694 Z" />
			</g>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Main.js